const React = require('react');
const Ripple = require('../../../../../../../dumb/Ripple');
const {TrxDataDisplay} = require('../../../../../../../dumb/AdminHelpers/AdminTrx/');
// const {apiAdminRetailersPaymentDetails} = require('../../../../../../../../api/admin/payment');

module.exports = ({emitter}) => {
  return (
    <div>
      <TrxDataDisplay
        // requrest={apiAdminRetailersPaymentDetails}
        emitter={emitter}
      />
    </div>
  )
}
